import type { CreateLead, CreateLeadPayload } from './schema';
import type { FormSchema } from '~/landing/core/simulator/future-savings-planner';

import { formatDate } from '@polyseme/utils/date/date-utils';
import { formatCurrency } from '@polyseme/utils/number/number-utils';

import { createLeadPayloadSchema } from './schema';

export const generateSimulationDescription = ({
  futureSavingsPlanner: {
    birthDate,
    initialDeposit,
    monthlyPayment,
    retirementAge,
  },
  riskProfileLabel,
  taxSavingsSimulator: { householdAnnualIncome, taxSharesHousehold },
}: FormSchema & {
  riskProfileLabel: string;
}) =>
  [
    `Date de naissance: ${formatDate(birthDate, 'DD MMMM YYYY')}`,
    `Versement initial: ${formatCurrency(initialDeposit)}`,
    `Versement mensuel: ${formatCurrency(monthlyPayment)}`,
    `Âge de départ: ${retirementAge} ans`,
    `Profil de risque: ${riskProfileLabel}`,
    `Revenu annuel du foyer: ${formatCurrency(householdAnnualIncome)}`,
    `Parts fiscales: ${taxSharesHousehold}`,
  ].join(' | ');

export const mapCreateLead = (lead: CreateLead): CreateLeadPayload => {
  const leads = [
    {
      ...lead,
      contactChannel: 'Web',
      leadCategory: 'Retraite',
      leadType: 'Simulateur Garance',
      marketingConsents: [
        'Email',
        'Courrier',
        'SMS',
        'Espace Client',
        'Telephone',
      ].join(';'),
    },
  ] satisfies CreateLeadPayload;

  return createLeadPayloadSchema.parse(leads);
};
